import Header from 'editorjs-header-with-alignment';
import Image from '@editorjs/image';
import List from '@editorjs/list';
import Paragraph from '@editorjs/paragraph';

export const EDITOR_JS_TOOLS = {
  // NOTE: Paragraph is default tool. Declare only when you want to change paragraph option.
  // paragraph: Paragraph,
  header: {
    class: Header,
    config: {
      placeholder: 'Enter a header',
      levels: [1, 2, 3, 4, 5, 6],
      defaultLevel: 3,
      defaultAlignment: 'left',
    },
  },
  image: {
    class: Image,
    config: {
      uploader: {
        /**
         * Upload file to the server and return an uploaded image data
         * @param {File} file - file selected from the device or pasted by drag-n-drop
         * @return {Promise.<{success, file: {url}}>}
         */
        uploadByFile(file: File): Promise<{ success: number; file: { url: string } }> {
          throw new Error('Please implement an  upload function for EditorJS to be able to upload images.' + file?.name);
        },
      },
      types: 'image/jpeg, image/png',
    },
  },
  list: List,
  paragraph: {
    class: Paragraph,
    inlineToolbar: true,
  },
};
